import Action from "./Action";

export default class JumpAction extends Action{

    constructor(lineNumber: number) {
        super(lineNumber);
    }
}